// extracted by mini-css-extract-plugin
module.exports = {"textContent":"noActiveSearchesSplash_textContent__2Ve8o","textImg":"noActiveSearchesSplash_textImg__UanR9","noActiveContainer":"noActiveSearchesSplash_noActiveContainer__3oyrm"};